import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import CandidateReview from "../components/CandidateReview";
import * as projectActions from "../../../../actions/project.actions";
import * as userActions from "../../../../actions/user.actions";

class CandidateReviewContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      projectId: null
    };

    this.submitCandidateReview = this.submitCandidateReview.bind(this);

    this.props.userActions.getMember(this.props.match.params.memberId);
    this.props.projectActions.checkReviewer(
      this.props.match.params.projectId,
      this.props.match.params.memberId
    );
  }

  getMappedAnswers(data) {
    const answers = [];

    _.forEach(data, (answer, index) => {
      const questionId = _.toInteger(index);

      if (answer && questionId) {
        answers.push({
          question_id: questionId,
          value: answer
        });
      }
    });

    return answers;
  }

  getMappedContacts(emails, names) {
    const contacts = [];

    _.forEach(emails, (email, questionId) => {
      if (email && questionId) {
        contacts.push({
          email: email,
          name: names[questionId] || "not filled"
        });
      }
    });

    return contacts;
  }

  submitCandidateReview(data) {
    const payload = {
      project_id: this.props.match.params.projectId,
      target_id: this.props.match.params.memberId,
      answers: this.getMappedAnswers(data),
      contacts: this.getMappedContacts(data.emails, data.names)
    };

    this.props.projectActions.storeReview(payload, "/company/projects");
  }

  render() {
    const candidate = this.props.user.member;
    const candidateName = `${candidate.first_name} ${candidate.last_name}`;

    return (
      <CandidateReview
        onSubmit={this.submitCandidateReview}
        candidateName={candidateName}
        sections={this.props.project.reviewQuestionsForEmployer}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    project: state.project,
    user: state.user
  };
};

const mapDispatchToProps = dispatch => {
  return {
    projectActions: bindActionCreators(projectActions, dispatch),
    userActions: bindActionCreators(userActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CandidateReviewContainer);



// WEBPACK FOOTER //
// ./src/routes/employer/candidateReview/containers/CandidateReviewContainer.js